import * as Yup from 'yup';

export const externalCustomerMappingValidationSchema = Yup.object().shape({
    mappings: Yup.array()
        .of(
            Yup.object().shape({
                externalCustomerId: Yup.string().required('app.error.required'),
            })
        )
        .required('app.error.required')
        .min(1, 'app.error.required'),
});
